<template>
  <div>
    <c-title>Projekt</c-title>
    <c-project-overview />
  </div>
</template>

<script>
import CProjectOverview from '@/components/project/CProjectOverview'
import CTitle from '@/components/CTitle'

export default {
  name: 'VProjectIntroduction',

  components: {
    CProjectOverview,
    CTitle
  }
}
</script>
